import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from 'ech-components/src/primitives';
import { IconSVG } from 'ech-components/src/primitives';
import { rem } from 'polished';

const StyledSocialbar = styled.nav(
  ({ color }: any) => css`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    @keyframes socialIconHover {
      0% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(1);
      }
      30% {
        opacity: 0.2;
        transform: translate(-50%, -50%) scale(2);
      }
      100% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(1);
      }
    }

    .shadow {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(1);
      opacity: 0;
      pointer-events: none;
    }

    svg {
      path {
        transform: scale(2.75);
        transform-origin: center;
      }
    }

    ${color &&
    css`
      svg path {
        fill: ${color};
      }
    `}
  `,
);

const StyledSocialLink = styled(Link)`
  cursor: pointer;
`;

const StyledSocialLinkBox = styled.span`
  display: flex;
  position: relative;
  cursor: pointer;

  a {
    padding: ${rem(8)} 0;
  }

  &:hover {
    .shadow {
      animation-name: socialIconHover;
      animation-duration: 350ms;
      opacity: 0;
    }
  }
`;

const Socialbar = ({ color }: SocialbarProps) => {
  return (
    <StyledSocialbar color={color}>
      <StyledSocialLinkBox>
        <StyledSocialLink
          linkText="EnergieSchweiz | LinkedIn"
          link={{
            href: 'https://www.linkedin.com/company/energieschweiz',
            title: 'EnergieSchweiz | LinkedIn',
            target: '_blank',
          }}
          color="light"
          iconAfter="EchIconSocialMediaLinkedin2White"
          iconSize="25"
          iconOnly
        />
        <IconSVG
          iconName="EchIconSocialMediaLinkedin2White"
          iconSize="25"
          className="shadow"
        />
      </StyledSocialLinkBox>
    </StyledSocialbar>
  );
};

export type SocialbarProps = {
  /** Class of the Socialbar */
  className?: string;
  /* Color of the icons */
  color?: string;
};

export default Socialbar;
